var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeExperienceLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 27.1855C24.7968 27.1855 27.8748 24.1077 27.8748 20.3107C27.8748 16.5139 24.7968 13.4359 21 13.4359C17.2032 13.4359 14.1251 16.5139 14.1251 20.3107C14.1251 24.1077 17.2032 27.1855 21 27.1855Z",
    stroke: "#292D32",
    strokeWidth: 3.30522
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53491 16.3006C6.87576 -2.78154 35.1463 -2.7595 39.4652 16.3226C41.9992 27.5163 35.0362 36.9912 28.9325 42.8525C24.5036 47.1272 17.4965 47.1272 13.0455 42.8525C6.9639 36.9912 0.000908457 27.4942 2.53491 16.3006Z",
    stroke: "#292D32",
    strokeWidth: 3.30522
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeExperienceLocation);
export default __webpack_public_path__ + "static/media/intake-experience-location.0ac23f6065b9f8938ee0c5858eed83fc.svg";
export { ForwardRef as ReactComponent };